var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoRecordingStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#C7EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4125 9.30625V15.0438C14.4125 15.5816 13.9742 16 13.4563 16H7.71875C7.18086 16 6.7625 15.5816 6.7625 15.0438V9.30625C6.7625 8.78828 7.18086 8.35 7.71875 8.35H13.4563C13.9742 8.35 14.4125 8.78828 14.4125 9.30625ZM18.2375 9.625V14.7449C18.2375 15.243 17.6398 15.5418 17.2215 15.2629L15.05 13.7488V10.6211L17.2215 9.10703C17.6398 8.82813 18.2375 9.12695 18.2375 9.625Z",
    fill: "#005585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecordingStart);
export default __webpack_public_path__ + "static/media/VIDEO_RECORDING_START.c9cfc8621a703257737b01867198cae1.svg";
export { ForwardRef as ReactComponent };